import Observer from "../../awrabet/utils/observer";
export * from "../../awrabet/utils/observer";
export default Observer;